import React from 'react';
import PropTypes from 'prop-types';
import { isOverseas } from '@moka-fe/ats.utils';
import classNames from 'classnames';
import { Input, Textarea } from 'sugar-design';

import PhoneInput from '../PhoneInput';
import CredentialsInput from '@/components/common/CredentialsInput';

import { getI18n } from '@/utils/i18n';

import styles from './index.cm.styl';

const i18n = getI18n();

const FormItem = ({
  isRequired,
  type,
  onChange,
  onBlur,
  defaultValue,
  secondDefaultValue, // 证件号码的类型
  errorMsg,
  children,
  title,
  mandatoryFields,
}) => {
  const staticInfo = {
    name: {
      placeholder: i18n.t`请输入候选人姓名`,
      title: i18n.t`姓名`,
    },
    email: {
      placeholder: i18n.t`请输入候选人邮箱`,
      title: i18n.t`邮箱`,
    },
    phone: {
      placeholder: i18n.t`请输入候选人手机号`,
      title: i18n.t`电话`,
    },
    salary: {
      placeholder: i18n.t`请输入当前薪资`,
      title: i18n.t`当前薪资`,
    },
    aimSalary: {
      placeholder: i18n.t`请输入期望薪资`,
      title: i18n.t`期望薪资`,
    },
    citizenId: {
      placeholder: i18n.t`请输入身份证号码`,
      title: i18n.t`身份证`,
    },
  };

  let inputTitle = title;
  let inputEl;
  let placeholder;
  switch (type) {
    case 'name':
    case 'email':
    case 'salary':
    case 'aimSalary':
      inputEl = (
        <Input
          className={styles.fullWidth}
          placeholder={staticInfo[type].placeholder}
          value={defaultValue}
          error={errorMsg}
          onBlur={onBlur}
          onChange={onChange}
        />
      );
      break;
    case 'phone':
      inputEl = (
        <PhoneInput
          containerClassName="form-item__phone"
          placeholder={staticInfo[type].placeholder}
          codePlaceholder={isOverseas ? '' : void 0}
          value={defaultValue}
          error={errorMsg}
          onBlur={onBlur}
          onChange={onChange}
        />
      );
      break;
    case 'headhunterRecommendComment':
      placeholder = i18n.t`请输入推荐评语`;
      inputTitle = i18n.t`推荐评语`;
      inputEl = (
        <Textarea
          stretched
          className={classNames({ [styles.error]: errorMsg, [styles.itemTextarea]: true })}
          placeholder={placeholder}
          value={defaultValue}
          onBlur={onBlur}
          onChange={onChange}
        />
      );
      break;
    case 'citizenId':
      inputEl = (
        <CredentialsInput
          placeholder={staticInfo[type].placeholder}
          // 详见https://wiki.mokahr.com/pages/viewpage.action?pageId=142526001
          prohibitedCertificateType={
            mandatoryFields.includes(type) ? [2, 3, 4, 5, 6, 7, 8, 9, 10] : []
          }
          value={defaultValue}
          typeValue={secondDefaultValue}
          error={errorMsg}
          onChange={onChange}
          onBlur={onBlur}
        />
      );
      break;
  }

  return (
    <div className={`form-item form-item-${type}`}>
      <div className="form-item__title">
        {inputTitle || staticInfo[type].title}
        {isRequired && <span className="is-required">{i18n.t`必填`}</span>}
      </div>

      <div className="form-item__content">{children || inputEl}</div>
    </div>
  );
};

FormItem.propTypes = {
  isRequired: PropTypes.bool,
  type: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  defaultValue: PropTypes.string,
  errorMsg: PropTypes.string,
  children: PropTypes.element,
};

export default FormItem;
